import api from "../api";

export class AccountTabsApi {
    endpoint = null;

    setEndpoint(endpoint) {
        this.endpoint = endpoint || null;
    }

    async fetchState(params = {}) {
        if (!this.endpoint) {
            throw new Error("Account tabs endpoint is not configured");
        }

        return api.get(this.endpoint, { params });
    }
}

export default new AccountTabsApi();

